var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.5V7.5C27.5 6.1125 26.375 5 25 5H5C3.625 5 2.5125 6.1125 2.5125 7.5V12.5C3.8875 12.5 5 13.625 5 15C5 16.375 3.8875 17.5 2.5 17.5V22.5C2.5 23.875 3.625 25 5 25H25C26.375 25 27.5 23.875 27.5 22.5V17.5C26.125 17.5 25 16.375 25 15C25 13.625 26.125 12.5 27.5 12.5ZM25 10.675C23.5125 11.5375 22.5 13.1625 22.5 15C22.5 16.8375 23.5125 18.4625 25 19.325V22.5H5V19.325C6.4875 18.4625 7.5 16.8375 7.5 15C7.5 13.15 6.5 11.5375 5.0125 10.675L5 7.5H25V10.675ZM13.75 18.75H16.25V21.25H13.75V18.75ZM13.75 13.75H16.25V16.25H13.75V13.75ZM13.75 8.75H16.25V11.25H13.75V8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTicket);
export default __webpack_public_path__ + "static/media/Close Ticket.a7ceec08e07c8ee400b29be43c935e85.svg";
export { ForwardRef as ReactComponent };